import * as Redux from 'redux';
import { DIFFERENT_ACCOUNT_LOGIN, LOGIN, SIGNOUT, SAME_ACCOUNT_LOGIN, initialAuthState } from './auth.constants';
import { UPDATE_ACCOUNT } from '../account/Constants';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { AuthActionTypes, AuthResponse, AuthState } from './auth.types';
import { REVERT_TO_INITIAL_STATE } from '../app/app.const';

const authReducer: Redux.Reducer<AuthState> =
  (authState: AuthState = initialAuthState,
   action: ReduxAction<AuthActionTypes, SimpleResponse<AuthResponse>>): AuthState => {
  switch (action.type) {
    case `${LOGIN}_FULFILLED`:
      return { ...authState,
        account: action.payload.body.account,
        authToken: action.payload.body.authToken,
        statusCode: action.payload.statusCode,
        email: action.meta!.email!
      };
    case `${UPDATE_ACCOUNT}_FULFILLED`:
      return { ...authState,
        statusCode: action.payload.statusCode,
        account: action.payload.body.entity
      };
    case `${SIGNOUT}_FULFILLED`:
      return initialAuthState;
    case DIFFERENT_ACCOUNT_LOGIN:
      return { ...authState,
        differentAccountLogin: true
      };
    case REVERT_TO_INITIAL_STATE:
      return initialAuthState;
    case SAME_ACCOUNT_LOGIN:
      return { ...authState,
        differentAccountLogin: false
      };
    default:
      return authState;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/auth/auth.reducer.tsx